import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { NotificationResponse } from '../../../../core/models/notification.model';

export const LayoutActions = createActionGroup({
  source: 'Layout',
  events: {
    'Load Notifications': props<{ showLoading?: boolean }>(),
    'Load Notifications Success': props<{
      notifications: NotificationResponse[];
      unreadCount: number;
    }>(),
    'Load Notifications Failure': props<{ error: string }>(),
    'Mark Notification As Read': props<{ notificationId: string }>(),
    'Mark All Notifications As Read': emptyProps(),
    'Load Profile Image': emptyProps(),
    'Load Profile Image Success': props<{ profileImageUrl: string }>(),
    'Load Profile Image Failure': emptyProps(),
    'Profile Image Updated': props<{ profileImageUrl: string }>(),
  },
});
